<app-navbar></app-navbar>

<div class="h-screen w-full flex flex-col ">
  <!-- Tabs -->
  <div class="flex space-x-1 px-6 mt-20">
    <button
      (click)="onTabChange('inbound')"
      [ngClass]="{
        'bg-indigo-200 text-indigo-800': selectedTab === 'inbound',
        'text-black': selectedTab !== 'inbound'
      }"
      class="font-medium px-4 py-1 rounded-full transition-colors duration-500"
    >
      Inbound
    </button>
    <button
      (click)="onTabChange('outbound')"
      [ngClass]="{
        'bg-indigo-200 text-indigo-800': selectedTab === 'outbound',
        'text-black': selectedTab !== 'outbound'
      }"
      class="font-medium px-4 py-1 rounded-full transition-colors duration-500"
    >
      Outbound
    </button>
  </div>

  <!-- Main Content -->
  <div class="flex-1 flex ">
    <!-- Left Side: Chat Container -->
    <div
      class="flex-[2] flex justify-center "
      [ngClass]="{
        'items-center mb-28': !hasUserSentMessage,
        'items-start mt-4': hasUserSentMessage
      }">
      <div
        class="flex-[3] max-w-4xl bg-[#ffffff9c] rounded-xl p-6 flex flex-col transition-all duration-300"
        [ngClass]="{
          'h-auto': !hasUserSentMessage,
          'h-[calc(100vh-140px)]': hasUserSentMessage
        }">
        <!-- Greeting -->
        <div *ngIf="!hasUserSentMessage" class="mb-4">
          <div class="text-xl text-black font-medium">Hi</div>
          <div class="text-xl text-black font-medium mt-1">
            Welcome to <span class="text-[#6683e2]">DEXCAT</span>
          </div>
        </div>

        <!-- Scrollable Chat Messages -->
        <div #chatContainer class="flex-1 overflow-y-auto max-h-[700px] pr-2">
          <div *ngFor="let msg of chatMessages" class="my-2">
            <div *ngIf="msg.type === 'table'" class="overflow-x-auto mt-2">
              <table class="min-w-full border text-sm text-left text-black">
                <thead class="bg-gray-100 text-gray-800">
                  <tr>
                    <th *ngFor="let col of msg.columns" class="px-4 py-2 border">{{ col }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of msg.tableData">
                    <td *ngFor="let col of msg.columns" class="px-4 py-2 border">
                      {{ row[col] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="msg.type === 'user'" class="flex justify-end mb-2">
              <div
                class="inline-block bg-gray-200 text-indigo-900 text-md font-normal px-4 py-2 rounded-xl shadow"
              >
                {{ msg.text }}
              </div>
            </div>

            <div *ngIf="msg.type === 'bot'" class="text-md text-left text-black font-normal">
              {{ msg.text }}
            </div>

            <div *ngIf="msg.type === 'chart'" class="text-sm text-left text-black font-normal flex flex-row items-center">
              <span>{{ msg.chartType }} chart</span>
              <button
                (click)="showChart(msg)"
                mat-icon-button
                class="ml-2 w-2 text-indigo-600 hover:text-indigo-300 transition"
              >
                <mat-icon>open_in_new</mat-icon> 
              </button>
            </div>
          </div>
        </div>

        <!-- Typing Indicator -->
        <div *ngIf="isLoading" class="text-md text-left text-gray-500 font-normal mb-4">
          <span>Typing</span>
          <span class="typing-dots">
            <span class="dot">.</span>
            <span class="dot">.</span>
            <span class="dot">.</span>
          </span>
        </div>

        <!-- Input Field -->
        <div class="mt-4 p-4 rounded-xl w-full bg-indigo-100 shadow-inner">
          <input
            matInput
            [(ngModel)]="entityName"
            (keydown.enter)="onSendMessage()"
            placeholder="Type your message..."
            class="bg-transparent w-full outline-none placeholder:text-gray-400 text-black"
          />

          <div class="flex justify-between mt-2 w-full">
            <!-- File Upload + Chips -->
            <div class="flex items-center space-x-2">
              <div>
                <button mat-icon-button color="primary" (click)="navigateTohome()" (click)="fileInput.click()">
                  <mat-icon>add</mat-icon>
                </button>
                <input
                  #fileInput
                  type="file"
                  accept=".json,.csv"
                  multiple
                  hidden
                  (change)="onFileSelected($event)"
                />
              </div>
              <div
                *ngFor="let file of uploadedFiles"
                class="px-3 py-1 border border-black rounded-full text-sm font-medium text-black"
              >
                {{ file.name }}
              </div>
            </div>

            <!-- Send Button -->
            <div class="flex justify-end">
              <div class="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center">
                <button mat-icon-button color="primary" (click)="onSendMessage()">
                  <mat-icon>north</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side: Chart Panel -->
    <div
      *ngIf="showChartsPanel && activeChart"
      class="flex-1 bg-white h-auto rounded-2xl p-6 shadow-lg border-black flex flex-col justify-center space-y-6"
    >
      <!-- Header -->
      <div class="flex items-center justify-between mb-4">
        <div class="text-2xl font-semibold text-gray-800">Charts</div>
        <button
          (click)="closeChartsPanel()"
          class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 overflow-y-auto space-y-4">
        <div class="bg-gray-100 rounded-xl p-4 shadow-sm">
          <ngx-charts-bar-vertical
            *ngIf="activeChart.chartType === 'bar'"
            [results]="activeChart.chartData"
            [view]="[350, 250]"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="false"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            xAxisLabel="Country"
            yAxisLabel="Value"
          >
          </ngx-charts-bar-vertical>
          <ngx-charts-line-chart
            *ngIf="activeChart.chartType === 'line'"
            [results]="activeChart.chartData"
            [view]="[350, 250]"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="false"
            [autoScale]="true"
          >
          </ngx-charts-line-chart>
        </div>
      </div>
    </div>
  </div>
</div>